enum APROVATION_ITEM_STATUS {
  PENDING = 'PENDING',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export default APROVATION_ITEM_STATUS
